import React, { useEffect, useState } from 'react'
import { RiWhatsappFill } from 'react-icons/ri';

export default function WhatsAppButton() {
    const [isVisible, setIsVisible] = useState(false);

    const listenToScroll = () => {
        let heightToHideFrom = 100;
        const winScroll = document.body.scrollTop ||
            document.documentElement.scrollTop;

        if (winScroll > heightToHideFrom) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", listenToScroll);
        return () =>
            window.removeEventListener("scroll", listenToScroll);
    }, [])

    return (
        isVisible ? (
            <div className='fixed bottom-5 z-50 cursor-pointer right-5'>
                <a
                    href="https://wa.me/+2348106079897?text=Hello%20there!%20I%20would%20like%20to%20know%20more%20about%20your%20products.%20I%27m%20visiting%20from%20vethinteriors.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className='text-amber-500 shadow-2xl shadow-black h-14 w-14 bg-white rounded-full flex items-center justify-center cursor-pointer animate-pulse transition-colors duration-200'>
                    <RiWhatsappFill size={25} className='text-amber-600'/>
                </a>
            </div>
        ) : null
    )
}
